import axios from 'axios'
import Vue from 'vue'
import { formatISO, parseISO, differenceInMinutes } from 'date-fns'
import { get, has, isArray } from 'lodash-es'
// import { router } from '@/js/plugins/router/index.js'
import ACTION_TYPES from './action-types'
import MUTATION_TYPES from './mutation-types'
import GETTER_TYPES from './getter-types'
import CONSTANTS from './constants'
import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import AIMEOS_ACTIONS from '@/js/plugins/store/modules/aimeos/actions/actions-types.js'
import {
  CONSTANTS as FILTER_CONSTANTS,
  GROUPS,
  // TYPE as FILTER_TYPES,
  // SITE_CONTROL_SCOPES,
} from '@/js/helper/filter-constants.js'
import { DP_ROLE } from '@/js/helper/dp-usermanagement-constants'
import {
  generateAttributeDataWithConfig,
  getTypeCodeId,
} from '@/js/helper/product-attributes-helper'
import { getActiveFiltersForScope, maxResultAge } from '@/js/helper/settings-filter.js'

import { WS_CONSTANTS } from '@/js/plugins/ws/ws-store-module/index.js'
import { TYPES as WS_ACTIONS } from '@/js/plugins/ws/ws-store-module/actions.js'
import { checkNotification } from '@/js/helper/messaging-check-helper.js'

export default {
  [ACTION_TYPES.SET_APP_CONFIG]: async ({ commit }, config) => {
    commit(MUTATION_TYPES.SET_APP_CONFIG, config)
  },
  [ACTION_TYPES.SET_APP_CONSENT]: async ({ commit }, consent) => {
    commit(MUTATION_TYPES.SET_APP_CONSENT, consent)
  },
  [ACTION_TYPES.SET_APP_CONFIG]: async ({ commit }, config) => {
    commit(MUTATION_TYPES.SET_APP_CONFIG, config)
  },
  [ACTION_TYPES.SET_LOGOUT_STATE]: async ({ commit }, logout) => {
    commit(MUTATION_TYPES.SET_LOGOUT_STATE, logout)
  },
  [ACTION_TYPES.SET_CURRENT_LOGOUT_TIME]: async ({ commit }, logout) => {
    // console.log(`SET_CURRENT_LOGOUT_TIME: ${logout}`)
    commit(MUTATION_TYPES.SET_CURRENT_LOGOUT_TIME, logout)
  },
  [ACTION_TYPES.SHOW_OVERLAY]: async ({ commit }) => {
    commit(MUTATION_TYPES.SET_OVERLAY_VISIBILITY, true)
  },
  [ACTION_TYPES.HIDE_OVERLAY]: async ({ commit }) => {
    commit(MUTATION_TYPES.SET_OVERLAY_VISIBILITY, false)
  },
  [ACTION_TYPES.SHOW_BASKET]: async ({ commit }) => {
    commit(MUTATION_TYPES.SET_BASKET_VISIBILITY, true)
  },
  [ACTION_TYPES.ADD_PORTAL_TARGET]: async ({ commit }, value = '') => {
    commit(MUTATION_TYPES.ADD_PORTAL_TARGET, value)
  },
  [ACTION_TYPES.HIDE_BASKET]: async ({ commit }) => {
    commit(MUTATION_TYPES.SET_BASKET_VISIBILITY, false)
  },
  [ACTION_TYPES.SHOW_NAVIGATION_DRAWER]: async ({ commit }) => {
    commit(MUTATION_TYPES.SET_NAVIGATION_DRAWER_VISIBILITY, true)
  },
  [ACTION_TYPES.HIDE_NAVIGATION_DRAWER]: async ({ commit }) => {
    commit(MUTATION_TYPES.SET_NAVIGATION_DRAWER_VISIBILITY, false)
  },
  // [ACTION_TYPES.SHOW_SEARCH_DIALOG]: async ({ state }, forceSwitch) => {
  //   if (!forceSwitch && get(router, ['currentRoute', 'meta', 'isSearchList'])) {
  //     return
  //   }
  //   // console.log(forceSwitch)
  //   // console.log(router.currentRoute)
  //   // console.log(state[CONSTANTS.SEARCH_SELECTION])
  //   if (
  //     state[CONSTANTS.SEARCH_SELECTION] &&
  //     router &&
  //     get(router, ['currentRoute', 'name']) !== state[CONSTANTS.SEARCH_SELECTION]
  //   ) {
  //     router.push({ name: state[CONSTANTS.SEARCH_SELECTION] })
  //   }
  // },
  [ACTION_TYPES.TRACK_GTM_EVENT]: (store, { type = 'event', data = {} }) => {
    Vue.gtm?.trackEvent({
      event: type,
      data: data,
    })
  },
  [ACTION_TYPES.GET_ALL_FILTER]: async ({ getters, commit, dispatch, state }) => {
    // console.log('APP/GET_ALL_FILTER: called')

    const now = new Date()
    const allScopeFilterUser = get(state, [CONSTANTS.FILTERS, FILTER_CONSTANTS.SCOPE.ALL, 'user'])
    const allScopeFilterLanguage = get(state, [
      CONSTANTS.FILTERS,
      FILTER_CONSTANTS.SCOPE.ALL,
      'lang',
    ])
    const allScopeFilterDate = get(state, [CONSTANTS.FILTERS, FILTER_CONSTANTS.SCOPE.ALL, 'date'])
    const allScopeAttributeCount = Object.keys(
      get(state, [CONSTANTS.FILTERS, FILTER_CONSTANTS.SCOPE.ALL, 'attributes'], {}),
    ).length

    // console.log('APP/GET_ALL_FILTER', {
    //   scopeFilterLanguage: allScopeFilterLanguage,
    //   currentLang: getters[GETTER_TYPES.LOCALE],
    // })
    // console.log('APP/GET_ALL_FILTER', {
    //   scopeFilterUser: allScopeFilterUser,
    //   user: getters[GETTER_TYPES.CUSTOMER_NUMBER],
    // })
    // console.log('APP/GET_ALL_FILTER', { allScopeAttributeCount, allScopeFilterDate })
    if (
      allScopeFilterUser === getters[GETTER_TYPES.CUSTOMER_NUMBER] &&
      allScopeFilterLanguage === getters[GETTER_TYPES.LOCALE] &&
      allScopeAttributeCount > 2 &&
      allScopeFilterDate &&
      differenceInMinutes(now, parseISO(allScopeFilterDate)) <= maxResultAge
    ) {
      // console.log('APP/GET_ALL_FILTER: CACHE')
      return get(state, [CONSTANTS.FILTERS, FILTER_CONSTANTS.SCOPE.ALL])
    }

    // console.log('APP/GET_ALL_FILTER: REQUEST')
    const data = await dispatch(
      `${STORE_MODULES.AIMEOS}/${AIMEOS_ACTIONS.GET_PRODUCT_ATTRIBUTES}`,
      { all: 1, allCount: 0, currentUser: getters[GETTER_TYPES.CUSTOMER_NUMBER] },
      { root: true },
    ).catch(error => Promise.reject(new Error(`FETCH ALL FILTER DATA: ${error.message}`)))
    // console.log('APP/GET_ALL_FILTER', data)
    const priceInfo = get(data, 'priceInfo', {})
    commit(MUTATION_TYPES.SET_FILTER_DATA, {
      scope: FILTER_CONSTANTS.SCOPE.ALL,
      date: formatISO(now),
      user: getters[GETTER_TYPES.CUSTOMER_NUMBER],
      lang: getters[GETTER_TYPES.LOCALE],
      catalogCounts: get(data, 'catalogCounts', {}),
      catalogTree: get(data, 'catalogTree', {}),
      pimCatalogTree: get(data, 'pimCatalogTree', {}),
      attributes: generateAttributeDataWithConfig(
        [
          ...get(data, 'data', []),
          {
            code: 'SearchPrice',
            id: 'SearchPrice',
            type: 'SearchPrice',
            values: [],
            maxPrice: {
              value: `${get(priceInfo, 'firstPrice', 20000)}`,
              currency: get(priceInfo, 'firstPriceCurrency', 'EUR'),
            },
          },
        ],
        'ALL',
      ),
    })

    // console.log('APP/GET_ALL_FILTER: finished')
    return get(state, [CONSTANTS.FILTERS, FILTER_CONSTANTS.SCOPE.ALL])
  },

  [ACTION_TYPES.GET_SCOPE_FILTER]: async ({ commit, dispatch, state, getters }, { scope }) => {
    // console.log('APP/GET_SCOPE_FILTER: called', scope)
    if (!getters[GETTER_TYPES.CUSTOMER_NUMBER]) {
      console.log('User is not logged in. Not fetching filter data.')
      return {}
    }
    await dispatch(ACTION_TYPES.GET_ALL_FILTER)

    const now = new Date()

    const scopeFilterUser = get(state, [CONSTANTS.FILTERS, scope, 'user'])
    const scopeFilterLanguage = get(state, [CONSTANTS.FILTERS, scope, 'lang'])
    const scopeFilterDate = get(state, [CONSTANTS.FILTERS, scope, 'date'])
    const scopeAttributeCount = Object.keys(
      get(state, [CONSTANTS.FILTERS, scope, 'attributes'], {}),
    ).length

    // console.log('APP/GET_SCOPE_FILTER', {
    //   scopeFilterLanguage,
    //   currentLang: getters[GETTER_TYPES.LOCALE],
    // })
    // console.log('APP/GET_SCOPE_FILTER', {
    //   scopeFilterUser,
    //   user: getters[GETTER_TYPES.CUSTOMER_NUMBER],
    // })
    // console.log('APP/GET_SCOPE_FILTER', { scopeAttributeCount, scopeFilterDate })

    if (
      scopeFilterUser === getters[GETTER_TYPES.CUSTOMER_NUMBER] &&
      scopeFilterLanguage === getters[GETTER_TYPES.LOCALE] &&
      scopeAttributeCount > 2 &&
      scopeFilterDate &&
      differenceInMinutes(now, parseISO(scopeFilterDate)) <= maxResultAge
    ) {
      // console.log(state[CONSTANTS.FILTERS]?.[scope])
      // console.log('APP/GET_SCOPE_FILTER: return existing data', scope)

      return get(state, [CONSTANTS.FILTERS, scope])
    }

    const activeFilters = getActiveFiltersForScope(scope)
    // console.log({ activeFilters })
    const filterAttributes = activeFilters.map(([type, attrs]) => [
      type,
      attrs.map(attr =>
        getters[GETTER_TYPES.ALL_ATTRIBUTE_CODE_TO_ID_MAP].get(getTypeCodeId(...attr)),
      ),
    ])
    // console.log({ filterAttributes })
    const params = {
      all: 0,
      currentUser: getters[GETTER_TYPES.CUSTOMER_NUMBER],
      scope: FILTER_CONSTANTS.IS_OUTLET[scope],
      productType: FILTER_CONSTANTS.FE_SCOPE_TO_PRODUCT_TYPE[scope],
      filterAttributes,
    }

    const scopeData = await dispatch(
      `${STORE_MODULES.AIMEOS}/${AIMEOS_ACTIONS.GET_PRODUCT_ATTRIBUTES}`,
      params,
      { root: true },
    ).catch(error => Promise.reject(new Error(`FETCH ${scope} FILTER DATA: ${error.message}`)))
    // console.log(scopeData)
    const scopePriceInfo = get(scopeData, 'priceInfo', {})
    const attributes = generateAttributeDataWithConfig(
      [
        ...get(scopeData, 'data', []),
        {
          code: 'SearchPrice',
          id: 'SearchPrice',
          type: 'SearchPrice',
          values: [],
          maxPrice: {
            productId: get(scopePriceInfo, 'productId'),
            productLabel: get(scopePriceInfo, 'name'),
            value: `${get(scopePriceInfo, 'firstPrice', 20000)}`,
            currency: get(scopePriceInfo, 'firstPriceCurrency', 'EUR'),
          },
        },
      ],
      scope,
    )

    const hasAllDefaultFilters = activeFilters.every(([type, searchAtrs]) => {
      return searchAtrs.every(([atrType, atrCode]) => {
        const resolvedType = has(GROUPS, atrType)
          ? GROUPS[atrType].find(groupAttrType => {
              return get(attributes, groupAttrType, []).find(atr => atr.code === atrCode)
            })
          : atrType
        const foundAtr = get(attributes, resolvedType, []).find(atr => atr.code === atrCode)
        return foundAtr && foundAtr.count
      })
    })

    // const scopePriceInfo = last(scopeData)
    commit(MUTATION_TYPES.SET_FILTER_DATA, {
      scope,
      date: formatISO(now),
      user: getters[GETTER_TYPES.CUSTOMER_NUMBER],
      lang: getters[GETTER_TYPES.LOCALE],
      catalogCounts: get(scopeData, 'catalogCounts', {}),
      catalogTree: get(scopeData, 'catalogTree', {}),
      pimCatalogTree: get(scopeData, 'pimCatalogTree', {}),
      attributes,
      hasAllDefaultFilters,
    })
    // console.log('APP/GET_SCOPE_FILTER: return new data', scope)
    return get(state, [CONSTANTS.FILTERS, scope])
  },
  [ACTION_TYPES.CHANGE_SCOPE]: async ({ commit, dispatch }, { scope }) => {
    // console.log('APP/CHANGE_SCOPE: called')
    commit(MUTATION_TYPES.SET_SCOPE, scope)

    return await dispatch(ACTION_TYPES.GET_SCOPE_FILTER, { scope }).catch(e => console.log(e))
  },

  [ACTION_TYPES.SET_SEARCH_IMMEDIATE]: ({ commit }, immediate) => {
    commit(MUTATION_TYPES.SET_SEARCH_IMMEDIATE, immediate)
  },
  [ACTION_TYPES.SET_PRODUCT_LIST_VIEW]: async ({ commit }) => {
    commit(MUTATION_TYPES.SET_PRODUCT_VIEW, CONSTANTS.PRODUCT_VIEW_TYPE.LIST)
  },
  [ACTION_TYPES.SET_PRODUCT_GRID_VIEW]: async ({ commit }) => {
    commit(MUTATION_TYPES.SET_PRODUCT_VIEW, CONSTANTS.PRODUCT_VIEW_TYPE.GRID)
  },
  [ACTION_TYPES.SET_DIMENSION]: async ({ commit }, dimension) => {
    commit(MUTATION_TYPES.SET_DIMENSIONS, dimension)
  },

  // Notifications
  [ACTION_TYPES.ADD_NOTIFICATION]: async ({ commit, getters }, notification) => {
    console.log(notification)
    console.log(checkNotification({ notification, getters }))
    if (!checkNotification({ notification, getters })) {
      return
    }
    commit(MUTATION_TYPES.ADD_NOTIFICATION, notification)
  },
  [ACTION_TYPES.REMOVE_NOTIFICATION]: async ({ commit, dispatch }, notifications) => {
    const items = Array.isArray(notifications) ? notifications : [notifications]
    let userEventIds = []
    items.forEach(item => {
      const { id, userEventId } = item
      commit(MUTATION_TYPES.REMOVE_NOTIFICATION_BY_ID, id)
      if (userEventId) {
        userEventIds.push(userEventId)
      }
    })
    if (!userEventIds.length) {
      return
    }
    await dispatch(
      `${STORE_MODULES[WS_CONSTANTS.MODULE_ID]}/${WS_ACTIONS.CALL_MESSAGES}`,
      {
        method: 'post',
        data: { id: userEventIds.join(',') },
      },
      { root: true },
    ).catch(e => console.log(e))
    dispatch(`${STORE_MODULES[WS_CONSTANTS.MODULE_ID]}/${WS_ACTIONS.GET_MESSAGES_INFO}`, null, {
      root: true,
    }).catch(e => console.log(e))
  },
  [ACTION_TYPES.GET_NEWS_UNREAD]: async ({ commit, getters }) => {
    if (!getters[GETTER_TYPES.HAS_ROLE](DP_ROLE.MESSAGING_NEWS_R.p)) {
      return
    }
    const url = `${getters[GETTER_TYPES.BU_NEWS_BASE_URL]}?activePage=1&itemsPerPage=1`
    const response = await axios.get(url)
    commit(MUTATION_TYPES.SET_NEWS_UNREAD, response?.data?.data?.meta?.pagination?.unread)
  },
  [ACTION_TYPES.GET_PAYMENT_TERMS]: async ({ commit, state, getters }, termData) => {
    const terms = isArray(termData) ? termData : [termData]
    const requestTerms = terms.filter(term => !state[CONSTANTS.PAYMENT_TERMS][term])
    if (!requestTerms.length) {
      return
    }

    const url = getters[GETTER_TYPES.PAYMENT_TERMS_URL]
    const lang = getters[GETTER_TYPES.LOCALE]
    const params = {
      method: 'POST',
      url,
      data: {
        terms,
        lang,
      },
    }

    const response = await axios(params).catch(error => {
      // return Promise.reject(new Error(error.message))
      console.log(error)
    })

    // ToDo Error?
    commit(MUTATION_TYPES.ADD_PAYMENT_TERMS, response?.data || {})
  },
  [ACTION_TYPES.SET_SELECTED_BRAND]: async ({ commit }, brand) => {
    commit(MUTATION_TYPES.SET_SELECTED_BRAND, brand)
  },
  [ACTION_TYPES.GET_ENVIRONMENT_DATA]: async ({ state, getters }) => {
    const url = `${getters[GETTER_TYPES.ADMIN_URL]}/feapi/env/${getters[GETTER_TYPES.ENVIRONMENT]}`
    const response = await axios.get(url).catch(error => {
      console.log(`fetching environment data failed:${error}`)
      state[CONSTANTS.ENVIRONMENT_DATA] = {}
      return {}
    })
    const status = response?.data?.status
    if (status !== 'success') {
      console.log(`fetching environment data resonse:${response?.data?.data}`)
      state[CONSTANTS.ENVIRONMENT_DATA] = {}
      return {}
    }
    state[CONSTANTS.ENVIRONMENT_DATA] = response?.data?.data
    return response
  },
}
